import React from 'react';
import { Todo } from '../types/todo';

interface TodoItemProps {
  todo: Todo;
  onToggleComplete: (todo: Todo) => void;
  onEdit: (todo: Todo) => void;
  onDelete: (id: number) => void;
}

const TodoItem: React.FC<TodoItemProps> = ({
  todo,
  onToggleComplete,
  onEdit,
  onDelete
}) => {
  // 期限日のフォーマットと状態チェック
  const formatDueDate = (dateString: string | null): { text: string; status: string } => {
    if (!dateString) {
      return { text: '', status: '' };
    }

    const dueDate = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    dueDate.setHours(0, 0, 0, 0);

    const diffTime = dueDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    const formattedDate = dueDate.toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    if (diffDays < 0) {
      return { text: `${formattedDate}（期限切れ）`, status: 'overdue' };
    } else if (diffDays === 0) {
      return { text: `${formattedDate}（今日）`, status: 'today' };
    } else if (diffDays === 1) {
      return { text: `${formattedDate}（明日）`, status: '' };
    } else {
      return { text: formattedDate, status: '' };
    }
  };

  const dueDateInfo = formatDueDate(todo.due_date);

  return (
    <div className={`todo-item ${todo.completed ? 'completed' : ''}`}>
      <div className="todo-item-header">
        <div
          className={`todo-checkbox ${todo.completed ? 'checked' : ''}`}
          onClick={() => onToggleComplete(todo)}
          role="checkbox"
          aria-checked={todo.completed}
          tabIndex={0}
          onKeyPress={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              onToggleComplete(todo);
            }
          }}
        />
        <div className="todo-content">
          <h3 className="todo-title">{todo.title}</h3>
          {todo.description && (
            <p className="todo-description">{todo.description}</p>
          )}
          <div className="todo-meta">
            {dueDateInfo.text && (
              <span className={`todo-due-date ${dueDateInfo.status}`}>
                📅 {dueDateInfo.text}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="todo-actions">
        <button
          className="todo-action-btn edit"
          onClick={() => onEdit(todo)}
        >
          編集
        </button>
        <button
          className="todo-action-btn delete"
          onClick={() => onDelete(todo.id)}
        >
          削除
        </button>
      </div>
    </div>
  );
};

export default TodoItem;
